import Model from './BaseModel'
import i18n from '@/plugins/i18n'
import moment from 'moment'

export default class Period extends Model {
    resourceName() {
        return 'periods'
    }

    fields() {
        return [
            'id',
            'customer_id',
            'external_key',
            'start_at',
            'end_at',
            'flg_charged',
            'due_at',
            'paid_at',
            'plan_name',
            'value',
            'customer_name',
            'canceled_at',
            'changed_at',
            'created_at',
            'updated_at',
            'deleted_at',
        ]
    }

    dates() {
        return {
            start_at: 'YYYY-MM-DD',
            end_at: 'YYYY-MM-DD',
            due_at: 'YYYY-MM-DD',
            paid_at: 'YYYY-MM-DD',
            canceled_at: 'YYYY-MM-DD',
            changed_at: 'YYYY-MM-DD',
            created_at: 'YYYY-MM-DD',
            updated_at: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedStartAt(period) {
                return period.start_at.isValid()
                    ? i18n.d(period.start_at, 'short')
                    : null
            },

            formattedEndAt(period) {
                return period.end_at.isValid()
                    ? i18n.d(period.end_at, 'short')
                    : null
            },

            formattedDueAt(period) {
                return period.due_at.isValid()
                    ? i18n.d(period.due_at, 'short')
                    : null
            },

            formattedPaidAt(period) {
                return period.paid_at.isValid()
                    ? i18n.d(period.paid_at, 'short')
                    : '-'
            },

            formattedCanceledAt(period) {
                return period.canceled_at.isValid()
                    ? i18n.d(period.canceled_at, 'datetime')
                    : null
            },

            formattedChangedAt(period) {
                return period.changed_at.isValid()
                    ? i18n.d(period.changed_at, 'datetime')
                    : null
            },

            formattedCreatedAt(period) {
                return period.created_at.isValid()
                    ? i18n.d(period.created_at, 'datetime')
                    : null
            },

            formattedUpdatedAt(period) {
                return period.updated_at.isValid()
                    ? i18n.d(period.updated_at, 'datetime')
                    : null
            },

            formattedDeletedAt(period) {
                return period.deleted_at.isValid()
                    ? i18n.d(period.deleted_at, 'datetime')
                    : null
            },

            canceled(period) {
                return period.canceled_at.isValid() ||
                    period.changed_at.isValid()
                    ? 'Cancelado'
                    : '-'
            },

            paidStatus(period) {
                if (period.paid_at.isValid()) {
                    return 'Pago'
                }

                if (
                    !period.paid_at.isValid() &&
                    period.due_at.isValid() &&
                    period.due_at >= moment().startOf('day')
                ) {
                    return 'Em aberto'
                }

                if (
                    !period.paid_at.isValid() &&
                    period.due_at.isValid() &&
                    period.due_at < moment().endOf('day')
                ) {
                    return 'Atrasado'
                }
            },

            paidColor(period) {
                if (period.paid_at.isValid()) {
                    return 'teal white--text'
                }

                if (
                    !period.paid_at.isValid() &&
                    period.due_at.isValid() &&
                    period.due_at >= moment().startOf('day')
                ) {
                    return 'yellow darken-3 white--text'
                }

                if (
                    !period.paid_at.isValid() &&
                    period.due_at.isValid() &&
                    period.due_at < moment().endOf('day')
                ) {
                    return 'red lighten-1 white--text'
                }
            },

            formattedValue(period) {
                return i18n.n(period.value, 'currency')
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.period.attributes.customerName'),
                value: 'customer_name',
                sortable: false,
            },
            {
                text: i18n.t('resources.period.attributes.planName'),
                value: 'plan_name',
                sortable: false,
            },
            {
                text: i18n.t('resources.period.attributes.startAt'),
                value: 'formattedStartAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.period.attributes.endAt'),
                value: 'formattedEndAt',
                sortable: false,
            },
            {
                text: i18n.t('resources.period.attributes.value'),
                value: 'formattedValue',
                sortable: false,
            },
        ]
    }
}
